import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMoveLocationContents, performMove, resolveMoveDestination, resolveMoveSource, validateMoveOrigin } from '../../redux/move';
export var useMoveFlow = function () {
    var dispatch = useDispatch();
    var isLoading = useSelector(function (state) { return state.move.isLoading; });
    var validateOrigin = useCallback(function (rawLocation) {
        var scanId = (rawLocation || '').trim();
        if (!scanId)
            return Promise.resolve({ ok: false, error: 'Scan a location' });
        return dispatch(validateMoveOrigin({ rawLocation: scanId })).unwrap();
    }, [dispatch]);
    var fetchContents = useCallback(function (locationSeqId) {
        return dispatch(fetchMoveLocationContents({ locationSeqId: locationSeqId })).unwrap();
    }, [dispatch]);
    var resolveSource = useCallback(function (originLocationSeqId, scanId) {
        var barcode = (scanId || '').trim();
        if (!barcode) {
            return Promise.resolve({ ok: false, errorMessage: 'Scan an item, container, or tag' });
        }
        return dispatch(resolveMoveSource({ originLocationSeqId: originLocationSeqId, scanId: barcode })).unwrap();
    }, [dispatch]);
    var resolveDestination = useCallback(function (scanId, moveUnitKind, sourceContainerId, sourceLocationSeqId) {
        var barcode = (scanId || '').trim();
        if (!barcode) {
            return Promise.resolve({ ok: false, errorMessage: 'Scan a location or container' });
        }
        return dispatch(resolveMoveDestination({ scanId: barcode, moveUnitKind: moveUnitKind, sourceContainerId: sourceContainerId, sourceLocationSeqId: sourceLocationSeqId })).unwrap();
    }, [dispatch]);
    var move = useCallback(function (args) { return dispatch(performMove(args)).unwrap(); }, [dispatch]);
    return { isLoading: isLoading, validateOrigin: validateOrigin, fetchContents: fetchContents, resolveSource: resolveSource, resolveDestination: resolveDestination, move: move };
};
export default useMoveFlow;
